module.exports = __webpack_public_path__ + "static/media/platform-icons.6c3f01ee.png";